<template>
    <div style="height: 100%;">
        <!--  -->
        <keep-alive :include="$store.state.keepAlive.list">
            <router-view :class="isBottomNav ? 'view' : ''"> </router-view>
        </keep-alive>
        <footer v-if="isBottomNav">
            <RouterLink :to="{ name: 'index' }" replace>
                <span class="appeal1"><i class="iconfont icon-m-dibudaohang-home"></i></span>
                <span class="appeal2"><i class="iconfont icon-m-dibudaohang-home"></i></span>
                <span class="name">首页</span>
            </RouterLink>
            <RouterLink :to="{ name: 'category' }" replace>
                <span class="video1"><i class="iconfont icon-m-dibudaohang-fenlei"></i></span>
                <span class="video2"><i class="iconfont icon-m-dibudaohang-fenlei"></i></span>
                <span class="name">目录</span>
            </RouterLink>
            <RouterLink v-if="kefu" :to="{ path: '/user/kefu' }" replace>
                <span class="video1"><svg-icon name="Headset-outlined" /></span>
                <span class="video2"><svg-icon name="Headset-outlined" /></span>
                <span class="name">客服</span>
            </RouterLink>
            <RouterLink v-if="order" :to="{ path: '/user/order/index' }" replace>
                <span class="video1"><svg-icon name="View-outlined" /></span>
                <span class="video2"><svg-icon name="View-outlined" /></span>
                <span class="name">订单</span>
            </RouterLink>
            <RouterLink :to="{ name: 'news' }" replace>
                <span class="video1"><i class="iconfont icon-m-haibao"></i></span>
                <span class="video2"><i class="iconfont icon-m-haibao"></i></span>
                <span class="name">消息</span>
            </RouterLink>
            <RouterLink :to="{ name: 'user' }" replace>
                <span class="video1"><i class="iconfont icon-m-wodelipinka2"></i></span>
                <span class="video2"><i class="iconfont icon-m-wodelipinka2"></i></span>
                <span class="name">我的</span>
            </RouterLink>
        </footer>
    </div>
</template>

<script>
export default {
    beforeRouteLeave(to, from, next) {
        next()
    },
    data() {
        return {
            appeal1: true,
            appeal2: false,
            tabbar: [],
            kefu: false,
            order: false,
        }
    },
    computed: {
        isBottomNav() {
            return this.$route.meta.title && !this.$route.meta.hidden
        }
    },
    watch: {
        keepAliveList(val) {
            // process.env.NODE_ENV == 'development' &&
            //     console.log(`[ keepAliveList ] ${val}`)
        },
        '$store.state.config.data': {
            handler(val) {
                // console.log('val', val);
                this.kefu = val && val.theme_defaulth5_nav_kefu && val.theme_defaulth5_nav_kefu == 1;
                this.order = val && val.theme_defaulth5_nav_order && val.theme_defaulth5_nav_order == 1;
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        const kefu = this.$tool.data.get('nav_kefu');
        const order = this.$tool.data.get('nav_order');
        this.kefu = kefu == 1;
        this.order = order == 1;
        // console.log('this.$store', this.$store.state.config);
    },
    mounted() {
        // console.log(this.$route);
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
// .view {
//   // padding-bottom: $footer-outer-height;
//   padding-bottom:
//     calc(
//       #{$footer-outer-height} + constant(safe-area-inset-bottom)
//     );
//   padding-bottom: calc(#{$footer-outer-height} + env(safe-area-inset-bottom));
// }
footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    // border-top: 1px solid #eee;
    // height: $footer-height;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    padding: 7px 0;
    max-width: 580px;
    margin: 0 auto;
    box-shadow: 1px 0px 3px 0px #ccc;

    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
    a {
        display: block;
        align-self: center;
        text-decoration: none;
        color: #202020;
        font-weight: 500;
        font-size: 18px;
        text-align: center;

        img {
            width: 30px;
            height: 30px;
            margin: auto;
        }

        .appeal1,
        .video1 {
            display: block;
        }

        .appeal2,
        .video2 {
            display: none;
        }

        &.router-link-active {
            color: #f72225;

            .appeal1,
            .video1 {
                display: none;
            }

            .appeal2,
            .video2 {
                display: block;
            }
        }

        .name {
            display: block;
            // font-weight: 400;
            margin-top: 1px;
            font-size: .6rem;
            line-height: .6rem;
        }

        .iconfont {
            font-size: 25px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/empty.vue